import React from "react";

const CopyRight = () => {
  return (
    <div className="copyright">
      <p>
        &copy; {new Date().getFullYear()} Uta Koßmagk <br /> Created by
        <a
          href="https://themeforest.net/user/ib-themes"
          target="_blank"
          rel="noreferrer"
        >
          KFM Digital Minds
        </a>
      </p>
    </div>
  );
};

export default CopyRight;
